export default __webpack_public_path__ + "static/1146-e05ecc2cb9b54059ca161c9e59a7a96c.gif";